
import React from "react";
import { Eye, Trash2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Card, CardFooter } from "@/components/ui/card";

interface PostEditorActionsProps {
  id?: string;
  slug: string;
  isDraft: boolean;
  isPending: boolean;
  togglePublishStatus: () => void;
  setShowDeleteDialog: (show: boolean) => void;
  handleViewArticle: () => void;
}

const PostEditorActions: React.FC<PostEditorActionsProps> = ({
  id,
  slug,
  isDraft,
  isPending,
  togglePublishStatus,
  setShowDeleteDialog,
  handleViewArticle,
}) => {
  const updateButtonText = isDraft ? "Save Draft" : "Publish";

  return (
    <Card className="shadow-sm">
      <CardFooter className="flex flex-col sm:flex-row items-center justify-between gap-4 py-4">
        {/* Left Side: Status Toggle & Delete */}
        <div className="flex items-center gap-4 w-full sm:w-auto">
          <div className="flex items-center space-x-2">
            <Switch
              id="status-toggle"
              checked={!isDraft}
              onCheckedChange={togglePublishStatus}
              aria-label="Toggle publish status"
            />
            <Label htmlFor="status-toggle" className={isDraft ? "text-muted-foreground" : "text-green-600 font-medium"}>
              {isDraft ? "Draft" : "Published"}
            </Label>
          </div>
          
          {id && (
            <Button
              type="button"
              variant="destructive"
              onClick={() => setShowDeleteDialog(true)}
              disabled={isPending}
            >
              <Trash2 className="mr-2 h-4 w-4" /> Delete
            </Button>
          )}
        </div>

        {/* Right Side: View & Update Actions */}
        <div className="flex items-center gap-4 w-full sm:w-auto">
          {slug && (
            <Button
              type="button"
              variant="outline"
              onClick={handleViewArticle}
              disabled={isPending || !slug}
            >
              <Eye className="mr-2 h-4 w-4" /> View Article
            </Button>
          )}

          <Button type="submit" disabled={isPending}>
            {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            {updateButtonText}
          </Button>
        </div>
      </CardFooter>
    </Card>
  );
};

export default PostEditorActions;
